/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plugins_Audio_DescriptionInputs */



/**
* | output |
* | --- |
* | "Plugins: Audio Description" |
*
* @param {Plugins_Audio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plugins_audio_description = /** @type {((inputs?: Plugins_Audio_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plugins_Audio_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plugins : Description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Plugins: Audiobeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Plugin: Descrizione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Плагины: Аудиоописание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Complementos: Descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插件：音频描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プラグイン: オーディオ説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लगइन्स: ऑडियो विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Plugins: Descrição de áudio")
	return /** @type {LocalizedString} */ ("Plugins: Audio Description")
});